<template>
   <header id="header">
        <b-navbar toggleable="sm" type="light" variant="light">
            <div class="container">
                <b-navbar-brand href="#">
                    <img class="brand-icon" :src="brandIcon" alt="Samba Maníacos">
                </b-navbar-brand>

                <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

                <b-collapse id="nav-collapse" is-nav>
                    <b-navbar-nav>
                        <b-nav-item href="/">Home</b-nav-item>
                        <b-nav-item href="/#sobre">{{ $t('menu.sobre') }}</b-nav-item>
                        <b-nav-item href="/#equipe">{{ $t('menu.equipe') }}</b-nav-item>
                        <b-nav-item href="/eventos">{{ $t('menu.eventos') }}</b-nav-item>
                        <b-nav-item href="#contato">{{ $t('menu.contato') }}</b-nav-item>
                        <b-nav-item href="/certificado" class="certificado">{{ $t('menu.certificado') }}</b-nav-item>
                        <b-nav-item v-if="!isAuthenticated" href="/customer/login" class="only-mobile">{{ $t('menu.login') }}</b-nav-item>
                        <b-nav-item v-if="isAuthenticated" href="/customer/logout" class="only-mobile">{{ $t('menu.logout') }}</b-nav-item>
                    </b-navbar-nav>

                    <!-- Right aligned nav items -->
                    <b-navbar-nav class="ml-auto">
                        <b-nav-item :href="social.facebook.link" target="_black" class="social-icons not-hover">
                            <img class="nav-flag-img" :src="social.facebook.icon" alt="Facebook">
                        </b-nav-item>
                        <b-nav-item :href="social.instagram.link" target="_black" class="social-icons not-hover">
                            <img class="nav-flag-img" :src="social.instagram.icon" alt="Instagram">
                        </b-nav-item>
                        <b-nav-item :href="social.twitter.link" target="_black" class="social-icons not-hover">
                            <img class="nav-flag-img" :src="social.twitter.icon" alt="Twitter">
                        </b-nav-item>
                        <b-nav-item :href="social.youtube.link" target="_black" class="social-icons not-hover">
                            <img class="nav-flag-img" :src="social.youtube.icon" alt="Youtube">
                        </b-nav-item>
                        <div class="separator"></div>
                        <b-nav-item-dropdown class="social-icons login not-hover" right>
                            <template slot="button-content">
                                <img class="nav-flag-img" :src="icons.profile" alt="Profile">
                            </template>
                            <b-dropdown-item v-if="!isAuthenticated" href="/customer/login">{{ $t('menu.login') }}</b-dropdown-item>
                            <b-dropdown-item v-if="!isAuthenticated" href="/customer/create">{{ $t('menu.create') }}</b-dropdown-item>
                            <b-dropdown-item v-if="isAuthenticated" href="/customer/logout">{{ $t('menu.logout') }}</b-dropdown-item>
                        </b-nav-item-dropdown>
                    </b-navbar-nav>
                </b-collapse>
            </div>
        </b-navbar>
    </header>
</template>
<script>
import store from '@/store'

import ImgSMIcon from '@/assets/img/logo/sm-icon.png'

import IcFacebook from '@/assets/img/icons/social/facebook.svg'
import IcInstagram from '@/assets/img/icons/social/instagram.svg'
import IcTwitter from '@/assets/img/icons/social/twitter.svg'
import IcYoutube from '@/assets/img/icons/social/youtube.svg'
import IcProfile from '@/assets/img/icons/profile.svg'

export default {
    name: 'Home',
    data: () => ({
        brandIcon: ImgSMIcon,
        social: {
            facebook: {
                link: 'https://www.facebook.com/sambamaniacos.oficial',
                icon: IcFacebook
            },
            instagram: {
                link: 'https://www.instagram.com/sambamaniacos/',
                icon: IcInstagram
            },
            twitter: {
                link: 'https://twitter.com/sambamaniacos',
                icon: IcTwitter
            },
            youtube: {
                link: 'https://www.youtube.com/results?search_query=sambamaniacos',
                icon: IcYoutube
            }
        },
        icons: {
            profile: IcProfile
        },
        isAuthenticated: store.getters['auth/hasToken']
    }),
    created () {
        console.log('Navbar, Created()')
    },
    mounted () {
        console.log('Navbar, Moutend()')
        let navbarEl = document.getElementsByClassName('navbar')[0]
        if (navbarEl) {
            if (location.pathname === '/') {
                window.addEventListener('scroll', function () {
                    let navbarHeight = navbarEl.offsetHeight
                    let screenHeight = window.innerHeight
                    let wn = window.scrollY
                    let goPoint = screenHeight - navbarHeight

                    if (wn > goPoint) { navbarEl.classList.add('navbar-expandida') } else { navbarEl.classList.remove('navbar-expandida') }
                })
            } else {
                navbarEl.classList.add('navbar-expandida')
            }
        }

        this.isAuthenticated = store.getters['auth/hasToken']
        console.log(store.getters['auth/hasToken'])
    }
}
</script>

<style lang="sass">
@import "../assets/sass/_mixin"

#header
    nav.navbar
        max-height: 70px
        position: fixed
        z-index: 9999
        left: 20px
        right: 20px
        top: 20px
        box-shadow: 0px 2px 15px #00000038
        @include transition(top .4s ease-in-out, left .4s ease-in-out, right .4s ease-in-out)
        @include device(mobile)
            &
                left: 0
                right: 0
                top: 0
        &.navbar-expandida
            left: 0
            right: 0
            top: 0
        .navbar-collapse
            @include device(mobile)
                &
                    margin-top: 20px
        a.navbar-brand
            @include device(mobile)
                &
                    padding: 0
                    margin: 0
                    margin-left: calc(50% - 30px)
            img.brand-icon
                max-width: 55px
        ul.ml-auto
            @include device(mobile)
                &
                    flex-direction: row
                    justify-content: center
        li a
            @include device(mobile)
                &
                    text-align: center
        li.certificado
            padding: 0 10px
            border: 1px solid #28a745
            border-radius: 9px
            margin-left: 10px
            a
                color: #008000
                font-weight: 500

        .separator
            height: 35px
            display: block
            border-left: 1.5px solid #7c7c7d
            margin: auto 10px
            @include device(mobile)
                &
                    display: none
        .social-icons.login
            @include device(mobile)
                &
                    display: none
        .social-icons
            img
                filter: brightness(0) invert(.3)
            &:hover
                img
                    -webkit-filter: none !important
                    filter: none!important
            a
                padding-right: .8rem!important
                padding-left: .8rem!important
                img
                    height: 25px

</style>
